<template>
    <div id="app">
        <PatientEligibility :Type="AppServiceID" />
    </div>
</template>

<script>
import Vue from 'vue';
import PatientEligibility from '@/components/Common/PatientEligibility.vue'
import LayoutDefault from '@/Common/Default/DefaultLayout.vue';
export default {

  data: function (){
        return {
        AppServiceID :'',
        }
    },
    components: {
        PatientEligibility
    },
 
    created: function() {
        this.$emit('update:layout', LayoutDefault);
        this.AppServiceID = this.$store.getters.GetHearingID;

    },    
    beforeCreate: function() {
        this.$store.dispatch('AddServiceID',this.$store.getters.GetHearingID);
        this.$store.dispatch('GetMenuItems',this.$store.getters.GetHearingID);
    },
}
</script>

<style>

</style>
